module.exports = __webpack_public_path__ + "img/Tawang Festival 2016.ecefad52.jpg";